<!--
  Cartão "Seu onboarding: N%" — a porta para Meu onboarding, no perfil e em Pagamento e uso
  (chamado New Shoes 2026-0079). Só aparece para quem tem jornada em andamento; quem não tem
  não vê nada (nem erro).
-->
<template>
  <router-link v-if="jornada" to="/meu-onboarding" class="cartao-implantacao" data-testid="cartao-implantacao">
    <span class="anel" aria-hidden="true">
      <svg width="56" height="56" viewBox="0 0 56 56">
        <circle cx="28" cy="28" r="23" fill="none" stroke="#edebe5" stroke-width="7" />
        <circle cx="28" cy="28" r="23" fill="none" stroke="#f2b705" stroke-width="7" stroke-linecap="round"
                :stroke-dasharray="`${arco} 145`" transform="rotate(-90 28 28)" />
      </svg>
    </span>
    <span class="texto">
      <strong>{{ t('Seu onboarding') }}: {{ jornada.percentual ?? 0 }}%</strong>
      <span>{{ subtitulo }}</span>
    </span>
    <span class="continuar">{{ t('Continuar') }}</span>
  </router-link>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useImplantacao } from '../../composables/useImplantacao';
import { permissionsService } from '../../services/permissionsService';

const { t } = useI18n();
const { jornadas, carregarMinhas } = useImplantacao();

const jornada = computed(() => jornadas.value.find((j) => j.situacao === 'em_andamento') ?? null);
const arco = computed(() => (2 * Math.PI * 23 * (jornada.value?.percentual ?? 0)) / 100);
const subtitulo = computed(() => {
  const j = jornada.value;
  if (!j) return '';
  const etapa = (j.etapas ?? []).find((e) => e.situacao === 'atual');
  const pend = j.pendencias_franqueado ?? 0;
  return `${etapa ? `${t('Etapa')} ${etapa.ordem}: ${t(etapa.titulo)}` : ''}${pend ? ` · ${pend} ${t('pendências com você')}` : ''}`;
});

onMounted(() => {
  // A jornada é do franqueado (e do Full, que pode ser vinculado a uma franquia).
  if (!permissionsService.isUserInGroups(['Full', 'Franqueado'])) return;
  carregarMinhas().catch(() => { /* sem cartão: a página segue normal */ });
});
</script>

<style scoped>
.cartao-implantacao { display: flex; align-items: center; gap: 16px; padding: 14px 18px; border-radius: 14px; border: 2px solid #f2b705; background: var(--p-content-background, #fff); color: inherit; text-decoration: none; margin-bottom: 16px; }
.anel { flex-shrink: 0; display: flex; }
.texto { flex: 1; display: flex; flex-direction: column; gap: 2px; }
.texto span { color: #5b6168; font-size: 14px; }
.continuar { min-height: 40px; display: inline-flex; align-items: center; padding: 0 16px; border-radius: 8px; background: #f2b705; color: #1f2328; font-weight: 800; }
</style>
